import { translate } from "../../../util/translate"

export const itemHeaders = [
  {
    text: translate['item.label.name'],
    value: 'name',
    width: 400,
  },
  {
    text: translate['item.label.category'],
    value: 'category.name',
    width: 200,
  },
  {
    text: translate['item.label.createdAt'],
    value: 'date_created',
    width: 150,
  },
  { value: 'actions', align: 'end', width: 100 },
]
